import { SingleSubjectPage } from './SingleSubjectPage';
export default SingleSubjectPage;
